export interface ModalProps {
  modalOpen: boolean;
  closeModal: (value: boolean) => void;
  heading: React.ReactNode;
  children: React.ReactNode;
  doNotClose?: boolean;
  className?: string | undefined;
  bodyClassName?: string | undefined;
  fullScreenOnMobile?: boolean;
  bottomSheetOnMobile?: boolean;
}

export interface ConfirmDeleteModalProps {
  deleteLabel?: string;
  handleDelete?: () => void;
}

// delete
export const confirmDelete = "delete"
export const confirmText = "Are you sure you want to delete this"

// update 
export const confirmUpdate = "Are you sure you want to update this"

// filter
export const filter = "filters"
export const clear = "clear"
export const close = "close"
export const apply = "apply"

// users & waitlist
export const approve = "approve"
export const cancel = "cancel"
export const confirm = "confirm"
export const submit = "submit"
export const reject = "reject"
export const reasonForBlock = "Reason for Block"
export const reasonForRejection = "Reason for Rejection"
export const textAreaPlaceholder = "Enter your reason here"
export const reasonLabel = "reason"

// questionnaire
export const questionTypeLabel = "question type"
export const assignLabel = "assign to"
export const categoryLabel = "category"
export const select = "select"
export const displayOrder = "display order"
export const questionLabel = "question"
export const dependencyLabel = "has dependent question?"
export const dependentQuestionLabel = "dependent question"
export const addOption = "add option"
export const add = "add"
export const update = "update"

// event
export const noUserFound = "No user found"
export const noParticipantFound = "No participant found"

// roles
